<template>
  <div class="apply-list">
    <h2 class="apply-list__title">
      {{ title }}
    </h2>
    <div class="apply-list__back" v-if="!drawerShow">
      <b-button variant="primary" class="btn-icon" @click="handleBack">
        <feather-icon icon="ArrowLeftIcon" />
      </b-button>
    </div>

    <gtable-crud
      ref="gtable-crud"
      :data="formatData"
      :option="option"
      :page="page"
      :loading="loading"
      :permission="permissionList"
      :before-open="beforeOpen"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
      @submit-add="submitAdd"
      @submit-edit="submitEdit"
    >
      <!-- 自定义列 -->
      <template slot="table-row" slot-scope="{ row, column }">
        <span v-if="column.field == 'form'">
          <template v-for="(item, key) in row.form">
            <p :key="key">
              {{ $t(`_staff.labelEmploymentApplication.${key}`) }}:&nbsp;
              <span class="text-primary">{{ item }}</span>
            </p>
          </template>
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span
          v-if="
            props.column.field === 'statusName' &&
              searchPerformance.includes(formId)
          "
        >
          <template v-if="props.row.status">
            <div class="status-tag" :class="computedColor(props.row)" />
            <span>
              {{
                props.row.status === 9 &&
                props.row.hrIsAudited &&
                props.row.hrIsAudited === 11
                  ? 'Audited'
                  : props.row.statusName
              }}
            </span>
          </template>
        </span>
      </template>

      <template slot="headMenuLeft" slot-scope="{ row }">
        <div
          v-if="viewAll === true && searchPerformance.includes(formId)"
          class="statistics"
        >
          Total Assessor in {{ statisticsObj.monthName }}:
          <b class="statistics-num">{{ statisticsObj.totalAssessorinMarch }}</b>
          , Submitted:
          <b class="statistics-num">{{ statisticsObj.submitted }}</b>
          ,
          <span class="pointer" @click="showDrawer">
            Not Submitted:
            <b class="statistics-num">{{ statisticsObj.notSubmitted }}</b>
          </span>
        </div>
        <span>
          <!-- 新增 -->
          <my-tooltip :tooltip="$t('_components.btns.add')">
            <b-button
              variant="primary"
              class="btn ml-0-5 mr-0-5"
              size="sm"
              @click="handleStepChange('add', row)"
            >
              <feather-icon icon="PlusIcon" size="18" />
            </b-button>
          </my-tooltip>

          <my-tooltip
            v-if="exportObj.model === 'table'"
            :tooltip="exportObj.title || $t('_components.btns.download')"
          >
            <b-button
              variant="warning"
              class="btn ml-0-5 mr-0-5"
              size="sm"
              @click="handleCustomDownload(exportObj)"
            >
              <feather-icon
                :icon="exportObj.icon || 'DownloadIcon'"
                size="18"
              />
            </b-button>
          </my-tooltip>

          <my-tooltip
            v-if="viewAll === true"
            :tooltip="$t('_components.btns.download')"
          >
            <b-button
              :disabled="downloading"
              variant="success"
              class="btn ml-0-5 mr-0-5"
              size="sm"
              @click="handleDownload"
            >
              <feather-icon icon="DownloadIcon" size="18" />
            </b-button>
          </my-tooltip>
        </span>
      </template>
      <!-- <template
        slot="menuLeft"
        slot-scope="{row}"
      >
        <my-tooltip
          v-if="row.status !== 1"
          :tooltip="$t('_components.btns.view')"
        >
          <feather-icon
            icon="SearchIcon"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleStepChange('viewPage',row)"
          />
        </my-tooltip>
        <my-tooltip
          v-if="exportObj.model === 'row' && passQuery(exportObj.query, row)"
          :tooltip="exportObj.title || $t('_components.btns.download')"
        >
          <feather-icon
            :icon="exportObj.icon || 'DownloadIcon'"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleCustomDownload(exportObj, row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.send')">
          <feather-icon
            v-if="getStatusOption(row.status).send"
            icon="SendIcon"
            class="text-success cursor-pointer"
            size="20"
            @click="handleStepChange('send', row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.cancel')">
          <feather-icon
            v-if="row.status === 5 && viewAll === true"
            icon="XIcon"
            style="margin-left: 5px"
            class="text-danger cursor-pointer"
            size="20"
            @click="cancelProcess(row)"
          />
        </my-tooltip>
        <my-tooltip
          v-if="row.status === 1"
          :tooltip="$t('_components.btns.edit')"
        >
          <feather-icon
            icon="Edit2Icon"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleStepChange('edit',row)"
          />
        </my-tooltip>
      </template> -->
      <template slot="menuLeft" slot-scope="{ row }">
        <span v-if="searchPerformance.includes(formId)">
          <my-tooltip
            v-if="row.status === 9 && viewAll === true"
            :tooltip="$t('_components.btns.pass')"
          >
            <feather-icon
              icon="CheckIcon"
              class="text-blue cursor-pointer ml-1"
              :class="{ disable: row.hrIsAudited && row.hrIsAudited === 11 }"
              size="20"
              @click="audiProcess(row)"
            />
          </my-tooltip>

          <my-tooltip
            v-if="row.status !== 1"
            :tooltip="$t('_components.btns.view')"
          >
            <feather-icon
              icon="SearchIcon"
              class="text-warning cursor-pointer ml-1"
              size="20"
              @click="handleStepChange('viewPage', row)"
            />
          </my-tooltip>
          <my-tooltip
            v-if="ShowCancel(row)"
            :tooltip="$t('_components.btns.cancel')"
          >
            <feather-icon
              icon="XIcon"
              style="margin-left: 5px"
              class="text-danger cursor-pointer"
              size="20"
              @click="cancelProcess(row)"
            />
          </my-tooltip>
          <my-tooltip
            v-if="ShowRecall(row)"
            :tooltip="$t('_components.btns.recall')"
          >
            <feather-icon
              icon="ArrowLeftCircleIcon"
              style="margin-left: 5px"
              class=" cursor-pointer"
              size="20"
              @click="recallProcess(row)"
            />
          </my-tooltip>
          <my-tooltip
            v-if="exportObj.model === 'row' && passQuery(exportObj.query, row)"
            :tooltip="exportObj.title || $t('_components.btns.download')"
          >
            <feather-icon
              :icon="exportObj.icon || 'DownloadIcon'"
              class="text-warning cursor-pointer ml-1"
              size="20"
              @click="handleCustomDownload(exportObj, row)"
            />
          </my-tooltip>
          <my-tooltip :tooltip="$t('_components.btns.send')">
            <feather-icon
              v-if="getStatusOption(row.status).send"
              icon="SendIcon"
              class="text-success cursor-pointer"
              size="20"
              @click="handleStepChange('send', row)"
            />
          </my-tooltip>
          <my-tooltip
            v-if="
              (row.status === 9 && viewAll === true) ||
                (row.status === 1 && viewAll === false)
            "
            :tooltip="$t('_components.btns.edit')"
          >
            <feather-icon
              icon="Edit2Icon"
              class="text-warning cursor-pointer ml-1"
              :class="{ disable: row.hrIsAudited && row.hrIsAudited === 11 }"
              size="20"
              @click="handleStepChangeAss('edit', row)"
            />
          </my-tooltip>
          <my-tooltip :tooltip="$t('_components.btns.reject')">
            <feather-icon
              v-if="row.status === 5 && viewAll === true"
              icon="XIcon"
              style="margin-left: 5px"
              class="text-danger cursor-pointer"
              size="20"
              @click="cancelProcess(row)"
            />
          </my-tooltip>
        </span>
        <span v-else>
          <my-tooltip
            v-if="row.status !== 1"
            :tooltip="$t('_components.btns.view')"
          >
            <feather-icon
              icon="SearchIcon"
              class="text-warning cursor-pointer ml-1"
              size="20"
              @click="handleStepChange('viewPage', row)"
            />
          </my-tooltip>
          <my-tooltip
            v-if="exportObj.model === 'row' && passQuery(exportObj.query, row)"
            :tooltip="exportObj.title || $t('_components.btns.download')"
          >
            <feather-icon
              :icon="exportObj.icon || 'DownloadIcon'"
              class="text-warning cursor-pointer ml-1"
              size="20"
              @click="handleCustomDownload(exportObj, row)"
            />
          </my-tooltip>
          <!-- <my-tooltip :tooltip="$t('_components.btns.send')">
            <feather-icon
              v-if="getStatusOption(row.status).send"
              icon="SendIcon"
              class="text-success cursor-pointer"
              size="20"
              @click="handleStepChange('send', row)"
            />
          </my-tooltip> -->
          <my-tooltip
            v-if="ShowCancel(row)"
            :tooltip="$t('_components.btns.cancel')"
          >
            <feather-icon
              icon="XIcon"
              style="margin-left: 5px"
              class="text-danger cursor-pointer"
              size="20"
              @click="cancelProcess(row)"
            />
          </my-tooltip>

          <my-tooltip
            v-if="ShowRecall(row)"
            :tooltip="$t('_components.btns.recall')"
          >
            <feather-icon
              icon="ArrowLeftCircleIcon"
              style="margin-left: 5px"
              class=" cursor-pointer"
              size="20"
              @click="recallProcess(row)"
            />
          </my-tooltip>

          <my-tooltip
            v-if="showEdit(row)"
            :tooltip="$t('_components.btns.edit')"
          >
            <feather-icon
              icon="Edit2Icon"
              class="text-warning cursor-pointer ml-1"
              size="20"
              @click="handleStepChange('edit', row)"
            />
          </my-tooltip>

          <my-tooltip
            v-if="showRemove(row)"
            :tooltip="$t('_components.btns.delete')"
          >
            <feather-icon
              icon="Trash2Icon"
              style="margin-left: 5px"
              class="text-danger cursor-pointer"
              size="20"
              @click="removeProcess(row)"
            />
          </my-tooltip>
        </span>
      </template>
    </gtable-crud>

    <c-modal
      :visible="modalShow"
      :title="modalTitle"
      size="lg"
      @close="modalShow = false"
      @modelConfirm="handleModelConfirm"
    >
      <template slot="content">
        <my-form
          v-if="getFormOption(stepMethodKey)"
          ref="overFormRef"
          :data="rowData"
          :loading="modalFormLoading"
          :option="getFormOption(stepMethodKey)"
          :footer-visible="false"
          width="auto"
        />
        <span v-else>
          {{ $t(`_staff.prompt.base.${stepMethodKey}Message`) }}
        </span>
      </template>
    </c-modal>
    <statistics
      :visible.sync="statisticsVisible"
      :data="statisticsObj.notSubmittedData"
    />
    <!-- 提交面试结果或者View页面 -->
    <c-drawer v-model="drawerShow" :before-close="handleBeforeClose">
      <component
        :is="stepMethodKey"
        v-if="drawerShow"
        :id="processId"
        :process-id="processId"
        :form-id="formId"
        :process-key="processKey"
        :process-instance-id="findData('processInstanceId')"
        :data="findData('map')"
        :hide-form-name="true"
        @close="handleDrawerClose"
      />
    </c-drawer>
  </div>
</template>

<script>
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import CModal from '@/components/crud/modal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import MyForm from '@/components/myForm/index.vue'
import { BButton, BFormRadio } from 'bootstrap-vue'
import CDrawer from '@/components/drawer.vue'
import MyTooltip from '@/components/myTooltip.vue'
import { mapGetters } from 'vuex'
import add from '@/views/apply/components/add.vue'
import edit from '@/views/apply/components/formEdit.vue'
import viewPage from '@/views/apply/components/viewPage.vue'
import { templateFormat } from '@/util/func'
import { customDownload } from '@/api/worker/process'
import formAPI from '@/api/base/formCustom'
import statistics from '@/views/apply/components/statistics.vue'
import performanceAPI from '@/api/staff/performance'
import moment from 'moment'

export default {
  components: {
    CModal,
    MyForm,
    BButton,
    add,
    edit,
    viewPage,
    CDrawer,
    MyTooltip,
    BFormRadio,
    statistics,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      data: [],
      option: {},
      loading: false,
      title: '',
      drawerTitle: '',
      modalShow: false,
      drawerShow: false,
      formSelectShow: false,
      processId: '',
      formId: '',
      processKey: '',
      processInstanceId: '',
      stepMethodKey: '',
      rowData: {},
      modalTitle: '',
      modalFormLoading: false,
      auditLoading: false,
      formatData: [],
      formList: [],
      viewAll: false,
      downloading: false,
      exportObj: {},
      searchPerformance: ['101', '102', '103', '104'],
      statisticsVisible: false,
      statisticsObj: {
        notSubmitted: 0,
        submitted: 0,
        totalAssessorinMarch: 0,
        notSubmittedData: [],
      },
    }
  },
  created() {
    const { title, processKey, formId, viewAll } = this.$route.query
    this.formId = formId
    this.viewAll = viewAll === 'true'
    this.title = title
    this.formList = [
      {
        formName: title,
        id: formId,
        processKey,
      },
    ]
  },
  computed: {
    ...mapGetters(['permission', 'userInfo']),
    permissionList() {
      return {
        addBtn: this.permission.menu_add,
        viewBtn: this.permission.menu_view,
        delBtn: this.permission.menu_del,
        editBtn: this.permission.menu_edit,
      }
    },
    statusOption() {
      // 0已发出面试邀请 2未参加面试 4等待面试 6未通过面试
      // 8通过面试,等待反馈 10已拒绝 14已确认,等待审批 16审批中
      // 18审批失败 20审批通过 22已发出offer 24拒绝offer 26接受offer
      const option = {
        1: {
          color: 'bg-gradient-secondary',
          send: true,
        },
        5: {
          color: 'bg-gradient-warning',
        },
        7: {
          color: 'bg-gradient-danger',
        },
        9: {
          color: 'bg-gradient-success',
        },
      }
      const defaultDictArr = this.$store.getters.dicts.dictBiz
      const findDict = defaultDictArr.find(
        (o) => o.code === 'interview_ process_status',
      )
      if (findDict) {
        findDict.children.forEach((item) => {
          if (option[item.dictKey]) {
            option[item.dictKey].label = item.dictValue
          }
        })
      }
      return option
    },
  },
  watch: {
    // formId(e) {
    //   if (e) {
    //     const find = this.formList.find(o => o.id === e) || {}
    //     this.processKey = find.processKey
    //     this.processInstanceId = find.processInstanceId
    //   }
    // },
  },
  mounted() {
    const query = this.$route.query || {}

    if (query.processId) {
      this.processId = query.processId
      applyAPI.detail({ id: this.processId }).then((res) => {
        const { data } = res.data
        this.stepMethodKey = 'viewPage'
        this.processKey = data.processKey
        this.processInstanceId = data.processInstanceId
        this.formId = data.formId
        this.rowData = data
        this.drawerShow = true
      })
    }
    // templateFormAPI.getList(1, -1, { formType: 2 }).then(res => {
    //   this.formList = res.data.data.records
    // })
    this.getPerformance()
    const find = this.formList.find((o) => o.id === this.formId) || {}
    this.processKey = find.processKey
    this.processInstanceId = find.processInstanceId

    if (this.formId) {
      formAPI.detail({ id: this.formId }).then((res) => {
        const formDetail = res.data.data
        const configuration = formDetail.configuration || '{}'
        this.exportObj = JSON.parse(configuration).export || {}
      })
    }
    templateFormAPI.detail({ formId: this.formId }).then((res) => {
      const t = res.data.data.records
      const temp = []
      t.forEach((item) => {
        const p = item
        p.formatOption = item.fieldOption ? JSON.parse(item.fieldOption) : ''
        temp.push(p)
      })
      const formatTemp = templateFormat(temp)
      // const firstCol = formatTemp.filter(o => !o.hide)[0]
      const showCol = formatTemp.filter(
        (o) => o.formOption.tableShow || o.search,
      )
      let baseCol = []
      if (this.formId === '2') {
        baseCol = [
          // {
          //   label: 'Vacation Type',
          //   field: 'vacationInfoId',
          //   search: true,
          //   searchBase: true,
          //   dictField: 'vacationInfoName',
          //   type: 'select',
          //   search: true,
          //   searchBase: true,
          //   width: '200px',
          //   dictBizCode: 'vacationInfo',
          // },
          {
            label: this.$t('_staff.labelLeaverecord.leaveStartTime'),
            field: 'leaveStartTime',
          },

          {
            label: this.$t('_staff.labelLeaverecord.leaveEndTime'),
            field: 'leaveEndTime',
          },
          {
            label: this.$t('_staff.labelLeaverecord.leaveDays'),
            field: 'usedDays',
            width: '120px',
          },
        ]
      }
      const searchList = ['23', '1']

      const resArr = [
        {
          label: this.i18n('createUser'),
          field: 'createUserName',
          type: 'input',
          sort: 9999998,
          // search: this.searchPerformance.includes(this.formId),
          // searchBase: true,
          width: '200px',
          fix: 'right',
          hidden: !this.searchPerformance.includes(this.formId),
        },

        {
          label: this.i18n('createUser'),
          field: 'createUser',
          sort: 9999999,
          width: '200px',
          search: true,
          searchBase: true,
          hidden: this.searchPerformance.includes(this.formId),
          type: 'select',
          dictCode: 'user',
        },

        // firstCol,
        ...showCol,
        ...baseCol,
        {
          label: this.i18n('createTime'),
          field: 'createTime',
          type: 'dateRangeNoTime',
          sort: 9999998,
          // search: [...searchList, ...this.searchPerformance].includes(
          //   this.formId
          // ),
          search: true,
          searchBase: true,
        },
        {
          label: this.i18n('status'),
          field: 'status',
          dictField: 'statusName',
          type: 'select',
          search: true,
          searchBase: true,
          dictBizCode: this.searchPerformance.includes(this.formId)
            ? 'process_status_new'
            : 'process_status',
          sort: -1,
          width: '180px',
        },
      ]
      const result = []
      resArr.forEach((item) => {
        const p = item
        if (['date', 'dateTime'].indexOf(p.type) !== -1) {
          p.type = 'dateRange'
        }
        result.push(p)
      })
      this.option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: (row) => row.status === 1, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 160, // 默认200
        form: true, // 是否使用自带form (默认true)
        drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)
        columns: result,
      }
      this.onLoad(this.page)
    })
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      const requestParams = Object.assign(
        params,
        this.query,
        { formId: this.formId },
        { isRemoveDraft: this.searchPerformance.includes(this.formId) },
      )
      let res = {}
      if (this.viewAll) {
        res = await applyAPI.getList(
          page.currentPage,
          page.pageSize,
          requestParams,
        )
      } else {
        res = await applyAPI.getMyList(
          page.currentPage,
          page.pageSize,
          requestParams,
        )
      }

      const { data } = res.data
      this.page.total = data.total
      const temp = data.records
      this.data = data.records
      const formatData = []
      temp.forEach((item) => {
        const form = item.map
        form.id = item.id
        form.processInstanceId = item.processInstanceId
        form.status = item.status
        form.statusName = item.statusName
        form.allowUpdate = item.bladeFlow.allowUpdate || ''
        form.createTime = item.createTime
        form.createUser = item.createUserName
        form.createUserName = item.createUserName
        form.hrIsAudited = item.hrIsAudited || ''
        form.createUserId = item.createUser
        formatData.push(form)
      })
      if (Number(this.formId) === 316) {
        this.mapPrApplicantName(formatData)
      }
      this.formatData = formatData
      this.loading = false
    },
    mapPrApplicantName(rows) {
      if (!rows?.length) return
      const applicantCol =
        this.option.columns?.find((col) =>
          /name of applicant/i.test(String(col.label || '')),
        )
        || this.option.columns?.find((col) => col.field === 'applicantId')
      const nameField = applicantCol?.dictField || 'applicantIdName'
      rows.forEach((row) => {
        if (row.applicantName) {
          row[nameField] = row.applicantName
        }
      })
    },
    ShowCancel(row) {
      console.log(row)
      const formIdList = [
        2,
        33,
        18,
        1,
        6,
        7,
        11,
        15,
        21,
        22,
        33,
        36,
        40,
        43,
        305,
        316, // PR Support Request
      ]
      const cFormId = [101, 102, 103, 104]
      const isShowForm =
        formIdList.includes(Number(this.formId)) ||
        (!this.viewAll && cFormId.includes(Number(this.formId)))
      if (row.status == 5 && isShowForm) {
        return true
      }
      return false
    },
    showEdit(row) {
      const formIdList = [
        2,
        33,
        18,
        1,
        6,
        7,
        11,
        15,
        21,
        22,
        33,
        36,
        40,
        43,
        305,
        316, // PR Support Request
      ]
      const cFormId = [101, 102, 103, 104]
      const isShowForm =
        formIdList.includes(Number(this.formId)) ||
        (!this.viewAll && cFormId.includes(Number(this.formId)))
      if (row.status == 1 && isShowForm) {
        return true
      }
      return false
    },
    showRemove(row) {
      const formIdList = [33]

      const isShowForm = formIdList.includes(Number(this.formId))

      if (row.status == 10 && isShowForm) {
        return true
      }
      return false
    },
    ShowRecall(row) {
      const formIdList = [
        2,
        33,
        18,
        1,
        6,
        7,
        11,
        15,
        21,
        22,
        33,
        36,
        40,
        43,
        305,
        316, // PR Support Request
      ]
      const cFormId = [101, 102, 103, 104]
      const isShowForm =
        formIdList.includes(Number(this.formId)) ||
        (!this.viewAll && cFormId.includes(Number(this.formId)))
      if (row.allowUpdate == 1 && row.status == 5 && isShowForm) {
        return true
      }
      return false
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase())
    },
    findData(key) {
      let res = {}
      if (this.processInstanceId) {
        res =
          this.data.find(
            (o) => o.processInstanceId === this.processInstanceId,
          ) || {}
      } else {
        res = this.data.find((o) => o.id === this.rowData.id) || {}
      }

      return res[key] ? JSON.parse(JSON.stringify(res[key])) : {}
    },
    // i18n
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      if (!this.drawerShow) {
        const searchParams = e
        this.option.columns.forEach((item) => {
          if (item.type === 'dateRange') {
            const range = searchParams[item.field]
            // const searchList = ['101'] // 处理查询同一天的数据，修改日期格式
            // if (searchList.includes(this.formId) && Array.isArray(range) && range[0]) {
            //   if (range[0] === range[1]) {
            //     range[0] += ' 00:00:01'
            //     range[1] += ' 23:59:59'
            //   }
            // }
            if (Array.isArray(range)) {
              if (range[0]) {
                ;[
                  searchParams[`${item.field}Start`],
                  searchParams[`${item.field}End`],
                ] = range
              }
              delete searchParams[item.field]
            }
          }
          if (item.type === 'dateRangeNoTime') {
            const range = searchParams[item.field]
            // const searchList = ['101'] // 处理查询同一天的数据，修改日期格式
            // if (searchList.includes(this.formId) && Array.isArray(range) && range[0]) {
            //   if (range[0] === range[1]) {
            //     range[0] += ' 00:00:01'
            //     range[1] += ' 23:59:59'
            //   }
            // }
            if (Array.isArray(range)) {
              if (range[0]) {
                // ;[
                //   searchParams[`${item.field}Start`],
                //   searchParams[`${item.field}End`],
                // ] = range
                searchParams[`${item.field}Start`] = moment(range[0]).format(
                  'YYYY-MM-DD 00:00:00',
                )
                searchParams[`${item.field}End`] = moment(range[1]).format(
                  'YYYY-MM-DD 23:59:59',
                )
              }
              delete searchParams[item.field]
            }
          }
          if (
            item.type === 'select' &&
            this.searchPerformance.includes(this.formId)
          ) {
            const range = searchParams[item.field]
            if (range === '11') {
              searchParams.hrIsAudited = range
            }
          }
        })
        this.query = searchParams
        this.page.currentPage = 1
        await this.onLoad(this.page, searchParams)
      }
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
      this.getPerformance()
    },
    // 点击下载按钮
    rowDel(e) {
      applyAPI
        .remove(e.id)
        .then(() => {
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.danger'),
              variant: 'danger',
            },
          })
        })
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    beforeOpen(done, type) {
      const formatDic = {
        add: 'Add',
        edit: 'Edit',
        view: 'View',
        upload: 'Upload',
      }
      this.drawerTitle = formatDic[type]
      done()
    },
    submitAdd(done, form) {
      const params = form
      applyAPI
        .add(params)
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: this.$t('system.user.tip.success'), // "操作成功!"
          })
          done()
        })
        .catch(() => {
          done()
        })
    },
    submitEdit(done, form) {
      applyAPI
        .update(form)
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: this.$t('system.user.tip.success'), // "操作成功!"
          })
          done()
        })
        .catch(() => {
          done()
        })
    },
    handleBeforeClose(done) {
      done()
      this.onLoad(this.page)
    },
    handleDrawerClose() {
      this.drawerShow = false
      this.onLoad(this.page)
    },
    handleBack() {
      this.$router.go(-1) // 返回上一层
    },
    getFormOption(key) {
      return this[`${key}Option`] || false
    },
    handleStepChange(key, row) {
      // this.formId = ''
      if (['add'].indexOf(key) !== -1) {
        this.drawerShow = true
      } else if (['edit', 'viewPage'].indexOf(key) !== -1) {
        // this.formId = row.formId
        this.processId = row.id
        this.drawerShow = true
      } else {
        this.modalShow = true
        this.modalTitle = this.$t(`_staff.prompt.base.${key}Title`)
      }
      this.stepMethodKey = key
      this.rowData = row || {}
    },
    handleStepChangeAss(key, row) {
      if (row.hrIsAudited !== 11) {
        // this.formId = ''
        if (['add'].indexOf(key) !== -1) {
          this.drawerShow = true
        } else if (['edit', 'viewPage'].indexOf(key) !== -1) {
          // this.formId = row.formId
          this.processId = row.id
          this.drawerShow = true
        } else {
          this.modalShow = true
          this.modalTitle = this.$t(`_staff.prompt.base.${key}Title`)
        }
        this.stepMethodKey = key
        this.rowData = row || {}
      }
    },
    cancelProcess(row) {
      // if (moment() > moment(row.leaveStartTime)) {
      //   this.$message.error(this.i18n('cancelOutTime'))

      //   return
      // }
      this.$bvModal
        .msgBoxConfirm(this.i18n('cancelProcessTip'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true
            applyAPI
              .cancelProcess({ processInstanceId: row.processInstanceId })
              .then((res) => {
                this.onLoad(this.page)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
              })
          }
          this.loading = false
        })
    },
    removeProcess(row) {
      this.$bvModal
        .msgBoxConfirm(this.i18n('audiProcessTip'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true
            applyAPI.removeNew(row.id).then((res) => {
              this.onLoad(this.page)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
            })
          }
          this.loading = false
        })
    },
    recallProcess(row) {
      this.$bvModal
        .msgBoxConfirm(this.i18n('recallProcessTip'), {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Yes',
          cancelTitle: 'Cancel',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loading = true
            applyAPI.processfieldecall({ id: row.id }).then((res) => {
              this.onLoad(this.page)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('_default.toast.title'),
                  icon: 'BellIcon',
                  text: this.$t('_default.toast.text.success'),
                  variant: 'success',
                },
              })
            })
          }
          this.loading = false
        })
    },
    // handleFormSelectConfirm() {
    //   this.drawerShow = true
    //   this.formSelectShow = false
    // },
    async handleModelConfirm() {
      this.modalFormLoading = true
      const key = this.stepMethodKey
      if (key === 'send') {
        applyAPI.start({ processId: this.rowData.id }).then((res) => {
          this.modalFormLoading = false
          this.modalShow = false
          this.onLoad(this.page)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      }
    },
    getStatusOption(status) {
      return this.statusOption[status] || {}
    },
    // 点击下载按钮
    handleDownload(e) {
      this.downloading = true
      if (!this.query.createTimeStart || !this.query.createTimeEnd) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: 'Please select the creation time and conduct the search',
            variant: 'info',
          },
        })
        this.downloading = false
        return
      }
      const stm = moment(this.query.createTimeStart)
      const etm = moment(this.query.createTimeEnd)

      // diff可以理解为减号 结束时间(etm) - 开始时间(stm) = 时间差(val)
      const val = etm.diff(stm, 'days')

      if (val > 365) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: 'The selected time interval should not exceed one year',
            variant: 'info',
          },
        })
        this.downloading = false
        return
      }

      const params = {
        type: this.viewAll ? 2 : 1,
        formId: this.formId,
        ...this.query,
      }
      applyAPI
        .exportProcess(
          Object.assign(params, this.query, {
            isRemoveDraft: this.searchPerformance.includes(this.formId),
          }),
        )
        .then((res) => {
          // 创建URL对象 URL.createObjectURL(object)
          const url = window.URL.createObjectURL(res.data)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          // 指定文件名&文件类型(后缀名)
          /**
           * 添加属性,并赋指定的值 el.setAttribute('download','zzz')
           * demo: <a href="abc.gif" download="zzz">
           * download属性的值即使当前要导出的文件的文件名
           * */
          link.setAttribute('download', `${this.title}.xlsx`)
          link.click()
          // 释放创建的对象(创建的新的URL必须通过该方法释放)
          window.URL.revokeObjectURL(url)
          this.downloading = false
        })
        .catch((err) => {
          this.downloading = false
        })
    },
    passQuery(query = {}, row) {
      let bool = true
      Object.keys(query).forEach((key) => {
        if (row[key] !== query[key]) {
          bool = false
        }
      })
      return bool
    },
    handleCustomDownload(exportObj = {}, row = null) {
      const { url, params, fileType, responseType } = exportObj
      const obj = {}
      if (row) {
        Object.keys(params).forEach((key) => {
          obj[params[key]] = row[key]
        })
      } else {
        Object.keys(params).forEach((key) => {
          obj[params[key]] = this[key]
        })
      }
      const fileName = `${this.title}.${fileType}`
      customDownload(url, obj, responseType).then((res) => {
        if (responseType === 'blob') {
          this.getBlobObj(res.data, fileName)
        } else {
          const a = document.createElement('a')
          a.href = res.data.data.link
          a.download = fileName
          a.click()
        }
      })
    },
    computedColor(param) {
      if (param.status === 9 && param.hrIsAudited === 11) {
        return 'bg-gradient-primary'
      }
      switch (param.status) {
        case 5:
          return 'bg-blue'
        case 7:
          return 'bg-gradient-danger'
        case 9:
          return 'bg-gradient-success'
        case 10:
          return 'bg-gradient-secondary'
        default:
          return ''
      }
    },
    audiProcess(row) {
      if (row.hrIsAudited !== 11) {
        this.$bvModal
          .msgBoxConfirm(this.i18n('audiProcessTip'), {
            title: 'Please Confirm',
            size: 'sm',
            okVariant: 'primary',
            okTitle: 'Yes',
            cancelTitle: 'Cancel',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              this.loading = true
              applyAPI.hrAudited({ id: row.id }).then((res) => {
                this.onLoad(this.page)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
              })
            }
            this.loading = false
          })
      }
    },
    showDrawer() {
      this.statisticsVisible = true
    },
    getPerformance() {
      performanceAPI.getMagnitude({}).then((res) => {
        const {
          notSubmitted,
          submitted,
          totalAssessorinMarch,
          NotSubmittedData,
          monthName,
        } = res.data.data
        this.statisticsObj.notSubmitted = notSubmitted
        this.statisticsObj.submitted = submitted
        this.statisticsObj.monthName = monthName
        this.statisticsObj.totalAssessorinMarch = totalAssessorinMarch
        this.statisticsObj.notSubmittedData = NotSubmittedData.map(
          (resData) => ({
            key: resData.userId,
            name: resData.name,
            code: resData.employeeCode,
            laseSend: resData.laseSend,
            userId: resData.userId,
          }),
        )
      })
    },
  },
}
</script>
<style lang="scss">
.apply-list {
  position: relative;
  .dropdown-menu {
    min-width: 13rem;
  }
  &__title {
    position: absolute;
    left: 50%;
    top: -50px;
    transform: translateX(-50%);
  }
  &__back {
    position: absolute;
    top: -50px;
    right: 0;
  }
}
.audit-container {
  text-align: center;
}
.bg-blue {
  background: var(--blue);
}
.text-blue {
  color: #7367f0;
  width: 26px;
  height: 26px;
}
.disable {
  color: #e4e4e4 !important;
}
.statistics {
  position: absolute;
  left: 0;
  font-size: 16px;
}
.statistics-num {
  font-size: 20px;
  color: #7367f0;
}
.pointer {
  cursor: pointer;
}
</style>
